import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/first';
import { transformNurseryDataLatLong } from '../helpers/dataTransform.helper';
import { Nursery } from '../models/Nursery';
import { Location } from '../models/Location';
import { LocationService } from './location.service';
import { StatesService } from './states.service';

@Injectable()
export class NurseryService {

  constructor(private http: HttpClient,
    private locationService: LocationService,
    private statesService: StatesService) { }

  getNurseryData(): Promise<Nursery[]> {
    return this.locationService.location.filter(l => l !== null).first().toPromise()
      .then(currentLocation => {
        return this.http.get('nursery')
        .toPromise()
        .then((data: any) => {
          return data.map(nursery => {
            if (nursery.lat_long === '') {
              console.warn(`nursery ${nursery.id} has no lat long`);
            }
            const [ lat, lng ] = nursery.lat_long.split(',');

            return new Nursery({
              ...nursery,
              lat_lng: <Location>({
                lat: parseFloat(lat),
                lng: parseFloat(lng)
              }),
              state: this.statesService.getStateFromIdOrDefault(nursery.state_id),
              currentLocation
            });
          });
        })
        .catch(err => {
          this.handleError(err);
          return err;
        });
      });
  }

  getNurseryDataId(id): Promise<any> {
    return this.http.get(`nursery/${id}`)
      .toPromise()
      .then(this.handleNurseryData)
      .catch(this.handleError);
  }

  getNurseryRatingData(): Promise<any> {
    return this.http.get('nursery_rating')
      .toPromise()
      .then(this.handleNurseryDataRating)
      .catch(this.handleError);
  }

  getNurseryRatingDataId(id): Promise<any> {
    return this.http.get(`nursery_rating/${id}`)
      .toPromise()
      .then(this.handleNurseryDataRating)
      .catch(this.handleError);
  }

  getNurseryProductDataId(id): Promise<any> {
    return this.http.get(`nursery_product/${id}`)
      .toPromise()
      .then(this.handleNurseryProduct)
      .catch(this.handleError);
  }

  getNurseryProductData(): Promise<any> {
    return this.http.get('nursery_product')
      .toPromise()
      .then(this.handleNurseryProduct)
      .catch(this.handleError);
  }

  getNurseryProductDetailData(): Promise<any> {
    return this.http.get('nursery_product_detail')
      .toPromise()
      .then(this.handleNurseryProductDetails)
      .catch(this.handleError);
  }

  postNewNursery(nurseryObj): Promise<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post('nursery', nurseryObj, options)
      .toPromise()
      .then(this.handlePostNursery)
      .catch(this.handleError);
  }

  updateNursery(nurseryObj): Promise<any> {
    const transformLatLngObjToString = (latLngObject) => {
      if (latLngObject && latLngObject.lat && latLngObject.lng) {
        return `${latLngObject.lat},${latLngObject.lng}`;
      }
      return '';
    }
    nurseryObj.lat_long = transformLatLngObjToString(nurseryObj.lat_long);

    let apiEndPoint = `nursery/${nurseryObj.id || -1}`;
    let formData:FormData = new FormData();
    formData.append('_method', 'PUT')
    for (let key in nurseryObj) {
      formData.append(key, nurseryObj[key]);
    }

    return this.http.post(apiEndPoint, formData)
      .toPromise()
      .then( this.handleUpdateNursery)
      .catch( this.handleError);
  }

  removeNursery(nurseryObj): Promise<any> {
    let formData:FormData = new FormData();
    formData.append('_method', 'DELETE')
    return this.http.post(`nursery/${nurseryObj.id || -1}`, formData)
      .toPromise()
      .then(this.handleNurseryDeleted)
      .catch(this.handleError);
  }

  uploadNurseryProduct(excelFile, nurseryObj, userObj) {
    let file: File = excelFile;
    let formData:FormData = new FormData();
    formData.append('excel', file, file.name);
    formData.append('nursery_id', nurseryObj.id);
    formData.append('user_id', userObj.id);
    return this.http.post('nursery-product-import', formData)
      .toPromise()
      .then(this.handleNurseryProductUploadSuccess)
      .catch(this.handleError);
  }

  getNurseryPhotos(): Promise<any> {
    return this.http.get('nursery_photo')
      .toPromise()
      .then(this.handleNurseryPhotos)
      .catch(this.handleError);
  }

  getNurseryPhotosId(id): Promise<any> {
    return this.http.get(`nursery_photos/${id}`)
      .toPromise()
      .then(this.handleNurseryPhotosId)
      .catch(this.handleError);
  }

  uploadNurseryPhoto(photoFile, nurseryObj) {
    let file: File = photoFile;
    let formData:FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('nursery_id', nurseryObj.id);
    return this.http.post(`nursery_photo`, formData)
      .toPromise()
      .then(this.handleNurseryPhotoUploadSuccess)
      .catch( this.handleError);
  }

  updateNurseryPhoto(photoObj) {
    let formData:FormData = new FormData();
    for (let key in photoObj) {
      formData.append(key, photoObj[key]);
    }
    formData.append('_method', 'PUT');
    return this.http.post(`/nursery_photo/${photoObj.id}`, formData)
      .toPromise()
      .then(this.handleNurseryPhotoUpdate)
      .catch(this.handleError);
  }

  removeNurseryPhoto(photoObj) {
    let formData:FormData = new FormData();
    formData.append('_method', 'DELETE')
    return this.http.post(`nursery_photo/${photoObj.id}`, formData)
      .toPromise()
      .then(this.handleNurseryPhotoDelete)
      .catch(this.handleError);
  }

  uploadNurseryProductPhoto(photoObj, nurseryObj) {
    console.log('uploadNurseryProductPhoto');
  }

  updateNurseryProductPhoto(photoOb) {
    console.log('updateNurseryProductPhoto');
  }

  removeNurseryProductPhoto(photoOb) {
    console.log('removeNurseryProductPhoto');
  }

  private handleError(error: any) {
    console.error(error);
    return error;
  }

  private handleNurseryData(res) {
    let body = res;
    body.map((nursery) => {
      nursery = transformNurseryDataLatLong(nursery);
      nursery.distanceToMe = this.locationService.getDistanceBetweenCurrentAndDestination(nursery.lat_lng);
    });
  }

  private handleNurseryDataSpecific(res) {
    let body = res.body;
    body.data = transformNurseryDataLatLong(body.data);
    return body.data || { };
  }

  private handleNurseryDataRating(res) {
    return res || { };
  }

  private handleNurseryProduct(res) {
    return res || { };
  }

  private handleNurseryProductDetails(res) {
    return res || { };
  }

  private handleNurseryProductUploadSuccess(res) {
    return res || { };
  }

  private handlePostNursery(res) {
    return res || { };
  }

  private handleUpdateNursery(res) {
    res = transformNurseryDataLatLong(res);
    return res || { };
  }

  private handleNurseryDeleted(res) {
    return res || { };
  }

  private handleNurseryPhotos(res) {
    return res || { };
  }

  private handleNurseryPhotosId(res) {
    return res || { };
  }

  private handleNurseryPhotoUploadSuccess(res) {
    return res || { };
  }

  private handleNurseryPhotoUpdate(res) {
    return res || { };
  }

  private handleNurseryPhotoDelete(res) {
    return res || { };
  }

  private handleNurseryStates(res) {
    return res || { };
  }
}